  (function () {
    var COLOUR_ORDER = ['black', 'blue', 'green', 'white', 'grey', 'brown', 'red', 'purple', 'pink', 'champagne', 'silver', 'gold', 'two-tone'];
    var COLOUR_LABEL = { black: cwT('Black'), blue: cwT('Blue'), green: cwT('Green'), white: cwT('White'), grey: cwT('Grey'), brown: cwT('Brown'), red: cwT('Red'), purple: cwT('Purple'), pink: cwT('Pink'), champagne: cwT('Champagne'), silver: cwT('Silver'), gold: cwT('Gold'), 'two-tone': cwT('Two-tone') };
    var SWATCH = { black: '#111', blue: '#2b58c7', green: '#1f7a4d', white: '#fff', grey: '#8a8a8a', brown: '#6b3e26', red: '#c8202a', purple: '#6a3bb5', pink: '#e79ab9', champagne: '#e8d3a2', silver: '#c9c9c9', gold: '#d4a63a', 'two-tone': 'linear-gradient(90deg,#c9c9c9 50%,#d4a63a 50%)' };
    var SORTS = [['featured', cwT('Featured')], ['newest', cwT('Newest')], ['price-asc', cwT('Price: low to high')], ['price-desc', cwT('Price: high to low')], ['title', cwT('A to Z')]];
    var DIAL_WORDS = [
      ['brown', /\b(brown|chocolate|cocoa|mocha|coffee|root beer|espresso)\b/g],
      ['black', /\b(black|onyx|noir|carbon)\b/g],
      ['blue', /\b(blue|navy|ice|tiffany|glacier|ocean|smurf|bluesy|sapphire|azure|teal)\b/g],
      ['green', /\b(green|emerald|olive|hulk|kermit|starbucks|army|forest|mint)\b/g],
      ['white', /\b(white|panda|snow|arctic|polar|pearl)\b/g],
      ['grey', /\b(grey|gray|rhodium|slate|meteorite|platinum|graphite|gunmetal)\b/g],
      ['red', /\b(red|burgundy|crimson|ruby|wine|maroon)\b/g],
      ['purple', /\b(purple|violet|aubergine|lavender)\b/g],
      ['pink', /\b(pink|rose|blush)\b/g],
      ['champagne', /\b(champagne|cream|ivory|beige)\b/g],
      ['silver', /\b(silver)\b/g],
      ['gold', /\b(gold|golden|yellow)\b/g]
    ];

    function colourIn(text) {
      var best = null;
      DIAL_WORDS.forEach(function (pair) {
        var re = pair[1], m;
        re.lastIndex = 0;
        while ((m = re.exec(text))) {
          if (!best || m.index > best.index) best = { index: m.index, name: pair[0] };
        }
      });
      return best ? best.name : '';
    }

    /* Dial colour from the product name: the colour word nearest "dial", otherwise the last colour word
       after the model name. Case words (two-tone, rose gold, white gold) are ignored so "Rose Gold Chocolate"
       reads as brown. A <colour>-dial tag on the product always wins over this guess. */
    function deriveColour(title) {
      var t = ' ' + String(title || '').toLowerCase().replace(/[()\[\],.]/g, ' ').replace(/\s+/g, ' ') + ' ';
      var cut = t.search(/ [-\u2013\u2014] /);
      if (cut >= 0) t = t.slice(cut + 3);
      t = t.replace(/two[- ]tone/g, ' ').replace(/rose gold/g, ' ').replace(/yellow gold/g, ' gold ').replace(/white gold/g, ' ');
      var m = t.match(/((?:\S+\s+){0,4})dial/);
      if (m) { var c = colourIn(' ' + m[1] + ' '); if (c) return c; }
      return colourIn(t);
    }

    function init() {
      var section = document.querySelector('[data-cat]');
      if (!section || section.dataset.catReady === 'true') return;
      section.dataset.catReady = 'true';

      var grid = section.querySelector('[data-cat-grid]');
      if (!grid) return;
      var $ = function (sel) { return section.querySelector(sel); };
      var $$ = function (sel, root) { return Array.prototype.slice.call((root || section).querySelectorAll(sel)); };

      var isShopAll = section.getAttribute('data-cat-shop-all') === 'true';
      var batch = Math.max(12, Number(section.getAttribute('data-cat-batch') || 48));
      var totalPages = Number(grid.getAttribute('data-cat-pages') || 1);
      var expectedTotal = Number(grid.getAttribute('data-cat-total') || 0);
      var catalogUrl = grid.getAttribute('data-cat-catalog') || '';
      var catalogPages = Number(grid.getAttribute('data-cat-catalog-pages') || 1);
      var allLoaded = totalPages <= 1;

      var search = $('[data-cat-search]');
      var searchClear = $('[data-cat-search-clear]');
      var chips = $$('[data-cat-chip]');
      var countEl = $('[data-cat-count]');
      var progress = $('[data-cat-progress]');
      var moreWrap = $('[data-cat-more]');
      var moreBtn = $('[data-cat-more-btn]');
      // Auto-load (Oct 6, 2026): a sentinel under the grid reveals the next batch about 600 px before
      // the end. Show more stays as the fallback when IntersectionObserver is missing or a fetch fails.
      var sentinel = $('[data-cat-sentinel]');
      var autoLoad = !!(sentinel && 'IntersectionObserver' in window);
      var lastShown = 0, lastMatched = 0;
      var empty = $('[data-cat-empty]');
      var resetBtn = $('[data-cat-reset]');
      var filterBadge = $('[data-cat-filter-badge]');
      var sheet = $('[data-cat-sheet]');
      var backdrop = $('[data-cat-backdrop]');
      var applyCount = $('[data-cat-apply-count]');
      var clearBtn = $('[data-cat-clear]');
      var colourWrap = $('[data-cat-options="colour"]');
      var sizeWrap = $('[data-cat-options="size"]');
      var sortWrap = $('[data-cat-options="sort"]');
      var sortGroup = $('[data-cat-group="sort"]');
      var floatBtn = $('[data-cat-float]');
      var bar = $('[data-cat-bar]');
      var pagination = section.querySelector('.cw-cat-pagination');

      var params = new URLSearchParams(window.location.search);
      var state = {
        q: (params.get('q') || '').toLowerCase().trim(),
        style: isShopAll ? (params.get('style') || 'all') : 'all',
        colour: params.get('colour') || '',
        size: params.get('size') || '',
        sort: params.get('sort') || 'featured',
        cap: batch
      };
      if (!SORTS.some(function (s) { return s[0] === state.sort; })) state.sort = 'featured';
      if (search) search.value = params.get('q') || '';

      function prep(el) {
        var title = el.getAttribute('data-title') || '';
        var colour = (el.getAttribute('data-colour') || '').toLowerCase();
        if (!COLOUR_LABEL[colour]) colour = deriveColour(title);
        el.setAttribute('data-colour', colour);
        return {
          el: el, title: title,
          search: el.getAttribute('data-search') || '',
          styles: el.getAttribute('data-style') || '',
          price: Number(el.getAttribute('data-price') || 0),
          created: Number(el.getAttribute('data-created') || 0),
          index: Number(el.getAttribute('data-index') || 0),
          colour: colour,
          size: el.getAttribute('data-size') || '',
          sizes: (el.getAttribute('data-size') || '').split('|').filter(Boolean)
        };
      }
      var items = $$('[data-cat-item]', grid).map(prep);

      function matches(it, skip) {
        if (state.q && it.search.indexOf(state.q) === -1) return false;
        if (state.style !== 'all' && it.styles.indexOf('|' + state.style + '|') === -1) return false;
        if (skip !== 'colour' && state.colour && it.colour !== state.colour) return false;
        if (skip !== 'size' && state.size && it.sizes.indexOf(state.size) === -1) return false;
        return true;
      }
      function compare(a, b) {
        if (state.sort === 'price-asc') return (a.price - b.price) || (a.index - b.index);
        if (state.sort === 'price-desc') return (b.price - a.price) || (a.index - b.index);
        if (state.sort === 'newest') return (b.created - a.created) || (a.index - b.index);
        if (state.sort === 'title') return a.title.localeCompare(b.title);
        return a.index - b.index;
      }
      function filtersActive() { return (state.colour ? 1 : 0) + (state.size ? 1 : 0); }
      function anyNarrowing() { return !!(state.q || state.style !== 'all' || state.colour || state.size); }

      function syncUrl() {
        if (!window.history || !window.history.replaceState) return;
        var p = new URLSearchParams();
        if (state.q) p.set('q', state.q);
        if (isShopAll && state.style !== 'all') p.set('style', state.style);
        if (state.colour) p.set('colour', state.colour);
        if (state.size) p.set('size', state.size);
        if (state.sort !== 'featured') p.set('sort', state.sort);
        var qs = p.toString();
        try { window.history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash); } catch (e) {}
      }

      function facetCounts(key) {
        var counts = {};
        items.forEach(function (it) {
          if (!matches(it, key)) return;
          var vals = key === 'size' ? it.sizes : [it[key]];
          vals.forEach(function (v) { if (v) counts[v] = (counts[v] || 0) + 1; });
        });
        return counts;
      }
      function renderFacet(wrap, key, values, label, swatch) {
        if (!wrap) return;
        var counts = facetCounts(key);
        var html = '';
        values.forEach(function (v) {
          var n = counts[v] || 0;
          var active = state[key] === v;
          if (!n && !active) return;
          html += '<button type="button" class="cw-cat-opt' + (active ? ' is-active' : '') + '" data-value="' + v + '"' + (n ? '' : ' disabled') + ' aria-pressed="' + (active ? 'true' : 'false') + '">' +
            (swatch ? '<i style="--swatch:' + SWATCH[v] + '"></i>' : '') + label(v) + '<small>' + n + '</small></button>';
        });
        wrap.innerHTML = html;
        var group = wrap.parentNode;
        if (group) group.hidden = !html;
      }
      function renderSort() {
        if (!sortWrap) return;
        sortWrap.innerHTML = SORTS.map(function (s) {
          var active = state.sort === s[0];
          return '<button type="button" class="cw-cat-opt' + (active ? ' is-active' : '') + '" data-value="' + s[0] + '" aria-pressed="' + (active ? 'true' : 'false') + '">' + s[1] + '</button>';
        }).join('');
      }
      function buildOptions() {
        renderFacet(colourWrap, 'colour', COLOUR_ORDER, function (v) { return COLOUR_LABEL[v]; }, true);
        var sizes = {};
        items.forEach(function (it) { it.sizes.forEach(function (v) { sizes[v] = true; }); });
        var sizeList = Object.keys(sizes).sort(function (a, b) { return Number(a) - Number(b); });
        renderFacet(sizeWrap, 'size', sizeList, function (v) { return cwT('{n} mm', { n: v }); }, false);
        renderSort();
      }

      var orderKey = '';
      function update(resetCap) {
        if (resetCap) state.cap = batch;
        var key = state.sort + ':' + items.length;
        if (key !== orderKey) {
          orderKey = key;
          items.sort(compare);
          var frag = document.createDocumentFragment();
          items.forEach(function (it) { frag.appendChild(it.el); });
          grid.appendChild(frag);
        }

        var shown = 0, matched = 0;
        items.forEach(function (it) {
          var ok = matches(it);
          if (ok) matched += 1;
          var visible = ok && shown < state.cap;
          if (visible) shown += 1;
          it.el.classList.toggle('is-hidden', !visible);
        });
        var total = matched;
        if (!allLoaded && !anyNarrowing()) total = Math.max(matched, expectedTotal);

        if (countEl) countEl.textContent = total;
        if (applyCount) applyCount.textContent = total;
        if (progress) progress.textContent = cwT('Showing {shown} of {total}', { shown: shown, total: total });
        // While the rest of the catalog is still loading, keep Show more up; it fills in when it lands.
        if (moreWrap) moreWrap.hidden = autoLoad || (allLoaded || anyNarrowing() ? shown >= matched : shown >= total);
        lastShown = shown; lastMatched = matched;
        if (empty) empty.hidden = matched !== 0;
        if (searchClear) searchClear.hidden = !state.q;
        chips.forEach(function (c) {
          var on = c.getAttribute('data-cat-chip') === state.style;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var active = filtersActive();
        if (filterBadge) { filterBadge.textContent = active; filterBadge.hidden = active === 0; }
        if (sheet && !sheet.hidden) buildOptions();
        syncUrl();
        // A filter can shrink the grid so the end is already on screen; keep filling until it is not.
        if (autoLoad) window.requestAnimationFrame(function () { if (nearEnd()) grow(); });
      }

      /* Sheet */
      var lastFocus = null;
      function openSheet(target) {
        if (!sheet) return;
        lastFocus = document.activeElement;
        buildOptions();
        if (backdrop) backdrop.hidden = false;
        sheet.hidden = false;
        document.documentElement.classList.add('cw-cat-sheet-open');
        if (target === 'sort' && sortGroup) { sortGroup.scrollIntoView({ block: 'start' }); }
        else { var body = sheet.querySelector('.cw-cat-sheet__body'); if (body) body.scrollTop = 0; }
        var close = sheet.querySelector('.cw-cat-sheet__close');
        if (close) close.focus();
      }
      function closeSheet() {
        if (!sheet || sheet.hidden) return;
        sheet.hidden = true;
        if (backdrop) backdrop.hidden = true;
        document.documentElement.classList.remove('cw-cat-sheet-open');
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }

      section.addEventListener('click', function (e) {
        var t = e.target;
        var opener = t.closest('[data-cat-open]');
        if (opener) { openSheet(opener.getAttribute('data-cat-open')); return; }
        if (t.closest('[data-cat-float]')) { openSheet('filter'); return; }
        if (t.closest('[data-cat-close]')) { closeSheet(); return; }
        var opt = t.closest('[data-cat-options] .cw-cat-opt');
        if (opt && !opt.disabled) {
          var key = opt.parentNode.getAttribute('data-cat-options');
          var v = opt.getAttribute('data-value');
          if (key === 'sort') state.sort = v;
          else state[key] = state[key] === v ? '' : v;
          update(true);
          return;
        }
        var chip = t.closest('button[data-cat-chip]');
        if (chip && isShopAll) { state.style = chip.getAttribute('data-cat-chip'); update(true); return; }
        if (t.closest('[data-cat-clear]')) { state.colour = ''; state.size = ''; update(true); return; }
        if (t.closest('[data-cat-reset]')) {
          state.q = ''; state.colour = ''; state.size = ''; if (isShopAll) state.style = 'all';
          if (search) search.value = '';
          update(true); return;
        }
        if (t.closest('[data-cat-more-btn]')) { state.cap += batch; update(false); return; }
        if (t.closest('[data-cat-search-clear]')) { state.q = ''; if (search) { search.value = ''; search.focus(); } update(true); return; }
      });

      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });

      if (search) {
        search.addEventListener('input', function () { state.q = search.value.toLowerCase().trim(); update(true); });
        search.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); search.blur(); } });
      }

      /* Floating Filter and sort button on phones once the toolbar has scrolled away */
      if (floatBtn && bar && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          var en = entries[0];
          floatBtn.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
        }, { rootMargin: '-140px 0px 0px 0px' });
        io.observe(bar);
      }

      /* More collections row arrows (desktop) */
      var row = section.querySelector('.cw-cat-more .cw-home-collections');
      if (row) {
        $$('.cw-cat-more .cw-cat-more__nav button').forEach(function (button) {
          button.addEventListener('click', function () {
            var card = row.querySelector('.cw-home-collection');
            var step = card ? (card.getBoundingClientRect().width + 16) * 2 : row.clientWidth;
            row.scrollBy({ left: button.getAttribute('data-dir') === 'next' ? step : -step, behavior: 'smooth' });
          });
        });
      }

      update(true);

      function nearEnd() {
        if (!sentinel) return false;
        return sentinel.getBoundingClientRect().top < window.innerHeight + 600;
      }
      var growing = false;
      function grow() {
        if (!autoLoad || growing) return;
        if (!allLoaded) queueRemaining();
        if (lastShown >= lastMatched) return;
        growing = true;
        state.cap += batch;
        update(false);
        window.requestAnimationFrame(function () {
          growing = false;
          if (nearEnd()) grow();
        });
      }
      if (autoLoad) {
        new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) grow();
        }, { rootMargin: '0px 0px 600px 0px' }).observe(sentinel);
      }

      /* The page renders only the first batch. The rest of the catalog comes from ?view=catalog
         (no header, footer or Shopify head data, grid items only, 250 per page) so search, chips,
         filters and sort cover every watch. Items already on the page are skipped. The server
         pagination stays for no-JS visitors and comes back if a fetch fails. The fetch waits for the
         first touch or for the browser to go idle after load, so it does not compete with the
         first-screen photos, unless the URL already asks for a filter, search or sort. */
      function loadRemainingPages() {
        if (allLoaded || !catalogUrl || !window.fetch || !window.DOMParser) return;
        if (pagination) pagination.style.display = 'none';
        var seen = {};
        items.forEach(function (it) { seen[it.el.getAttribute('data-id')] = true; });
        var pages = [];
        for (var p = 1; p <= catalogPages; p++) pages.push(p);
        Promise.all(pages.map(function (page) {
          return fetch(catalogUrl + '&page=' + page, { credentials: 'same-origin' })
            .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); });
        })).then(function (htmls) {
          var added = [];
          htmls.forEach(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            Array.prototype.forEach.call(doc.querySelectorAll('[data-cat-item]'), function (card) {
              var id = card.getAttribute('data-id');
              if (seen[id]) return;
              seen[id] = true;
              var node = document.importNode(card, true);
              node.classList.add('is-hidden');
              grid.appendChild(node);
              added.push(prep(node));
            });
          });
          items = items.concat(added);
          allLoaded = true;
          update(false);
          if (nearEnd()) grow();
        }).catch(function () {
          if (pagination) pagination.style.display = '';
          autoLoad = false;
          update(false);
        });
      }
      var remainingQueued = false;
      function queueRemaining() {
        if (remainingQueued) return;
        remainingQueued = true;
        loadRemainingPages();
      }
      if (pagination && !allLoaded && catalogUrl) pagination.style.display = 'none';
      if (anyNarrowing() || state.sort !== 'featured') queueRemaining();
      section.addEventListener('pointerdown', queueRemaining, { once: true, passive: true });
      section.addEventListener('keydown', queueRemaining, { once: true });
      var idle = function () {
        if ('requestIdleCallback' in window) window.requestIdleCallback(queueRemaining, { timeout: 4000 });
        else setTimeout(queueRemaining, 1500);
      };
      if (document.readyState === 'complete') idle();
      else window.addEventListener('load', idle, { once: true });
    }

    init();
    document.addEventListener('shopify:section:load', function () {
      var s = document.querySelector('[data-cat]');
      if (s) s.dataset.catReady = 'false';
      init();
    });
  })();
